<script lang="ts" setup>
import { computed } from 'vue'
import { type Organization } from '@/stores/auth/Auth'

interface Props {
    isActive?: boolean
    organization: Organization
    size?: number
    tooltipDisabled?: boolean
    marginLeft?: string | number
    marginRight?: string | number
    showBorder?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    isActive: false,
    tooltipDisabled: false,
    size: 40,
    marginLeft: 'auto',
    marginRight: 'auto',
    showBorder: true
})

const organizationName = computed<string>(() => {
    if (props.organization && props.organization.name) {
        return props.organization.name
    }
    return '-'
})
</script>

<template>
    <el-tooltip
        class="box-item"
        effect="dark"
        placement="right"
        :content="organizationName"
        :disabled="tooltipDisabled"
    >
        <prizific-avatar
            :style="{ borderWidth: showBorder ? 1 : 0 }"
            :text="organizationName"
            :image-name="organization.icon"
            :size="size"
            margin-left="0"
            margin-right="0"
        />
    </el-tooltip>
</template>

<style lang="scss" scoped></style>
